export default {
  en: {
    'login.components.forgot-email-panel.title': 'Forgot Email',
    'login.components.forgot-email-panel.instruction':
      'Contact support to request your email address',
  },
};
